import { PropsWithChildren } from 'react';
import ErrorBoundary from 'src/components/ErrorBoundary';
import { cn } from 'src/lib/utils';

type DashboardLayoutProps = PropsWithChildren<{
  /** Take the content pane's full height, for pages that scroll internally. */
  fill?: boolean;
}>;

const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  fill = false,
  children,
}) => {
  return (
    <ErrorBoundary>
      <div
        className={cn(
          'w-full min-w-0 max-w-full overflow-x-clip',
          fill && 'h-full',
        )}
      >
        {children}
      </div>
    </ErrorBoundary>
  );
};

export default DashboardLayout;
